module.exports = __webpack_public_path__ + "img/2Reihe_1.fcc2d2be.jpg";